<template>
<div>

    <filters-form @filtersSubmited="onFiltersSubmited" />

    <el-data-table 
        :resourceUrl="baseUrl"
        :externalFiltersValid="filters.valid || false"
        ref="dataTable">

        <template slot="tableActions">
            <a :disabled="downloadUrl == null" slot="top-buttons" class="btn btn-default btn-sm" @click="downloadReport()"><i class="fa fa-download"></i> Download</a>
        </template>

        <template slot="columns">
            <el-table-column
                prop="line_no"
                width="40"
                align="right"
                label="#">
            </el-table-column>
            <el-table-column
                prop="company_id_number"
                width="80"
                align="right"
                label="Código">
            </el-table-column>
            <el-table-column
                prop="id_number"
                width="80"
                align="right"
                label="Cédula">
            </el-table-column>
            <el-table-column
                prop="employee_name"
                label="Empleado">
            </el-table-column>
            <el-table-column
                prop="functional_area_description"
                label="Área">
            </el-table-column>
            <el-table-column
                prop="shifts_description"
                label="Turno">
            </el-table-column>
            <el-table-column
                prop="date_from"
                width="100"
                align="center"
                label="Desde">
            </el-table-column>
            <el-table-column
                prop="date_to"
                width="100"
                align="center"
                label="Hasta">
            </el-table-column>
        </template>

    </el-data-table>


</div>
</template>

<script>
    import filters_form from './filters-form.vue';
    import el_data_table from '../el-data-table.vue';
    export default {
        data() {
            return {
                baseUrl: '/reports/shiftassignment',
                downloadUrl: null,
                filters: {},
            }
        },
        watch: {
            '$route': function (to) {
                this.setDownloadUrl();
            }
        },
        mounted: function () {
            this.setDownloadUrl();
        },
        components: {
            'filters-form': filters_form,
            'el-data-table': el_data_table,
        },
        methods: {
            onFiltersSubmited(filters) {
                // console.log(filters);
                this.filters = filters;
            },
            setDownloadUrl: function () {
                // console.log(this.$route);
                this.queryString = $.param(this.$route.query);
                if (this.$route.query.date_from != undefined 
                    && this.$route.query.date_to != undefined 
                    && this.$route.query.date_from != null 
                    && this.$route.query.date_to != null) {
                    this.downloadUrl = '/api' + this.baseUrl+'/download?'+this.queryString;
                    // this.downloadUrl = '/api/reports/shiftassignmentdatestocolumns/download?'+this.queryString;
                } else {
                    this.downloadUrl = null;
                }
            },
            downloadReport: function () {
                if (this.downloadUrl != null) {
                    window.location.href = this.downloadUrl+'&token='+localStorage.getItem('id_token');
                }
            }
        }
    }
</script>
